import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Reinventing Travel",
      subtitle: "An ethical, local, and human vision of tomorrow's tourism.",
    },
    mission: {
      badge: "Our Mission",
      title: "Fair Tourism",
      description:
        "We believe travel should be accessible to everyone, without costly intermediaries. DONKEY TRAVEL allows owners to travel freely thanks to the value of their own property.",
    },
    philosophy: {
      badge: "Our Philosophy",
      title: "Made in France & Human",
      description:
        "Rooted in the Somme Valley, we defend an artisanal model against Tech giants. No obscure algorithms, just common sense and conviviality.",
      values: {
        fair: {
          title: "Fair",
          desc: "0% commission on exchanges. Just a transparent subscription.",
        },
        local: {
          title: "Local Roots",
          desc: "Proud of our French roots, we promote respectful tourism.",
        },
        community: {
          title: "Community",
          desc: "A private club of trusted owners who share the same values.",
        },
      },
    },
    team: {
      badge: "The Team",
      title: "Passionate people at your service",
      subtitle: "Behind the platform, humans who love to travel and share.",
      members: {
        ceo: {
          name: "Plük",
          role: "DONKEY TRAVEL creator • Developer • Airbnb Superhost for 4 years",
          bio: "For years, I hosted travelers in my own homes and realized I could have stayed in many of their places too if DONKEY TRAVEL had existed. That is exactly why I created DONKEY TRAVEL: so hosts can welcome each other and travel differently.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Platform architect, security guardian.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Head of Communications",
          bio: "The voice of DONKEY TRAVEL to our community.",
        },
      },
    },
    investors: {
      badge: "Investors",
      title: "Join the Adventure",
      description:
        "DONKEY TRAVEL is growing fast. We are looking for partners who share our vision of sustainable and fair tourism.",
      cta: "Contact us to invest",
    },
  },
  trokOrigin: {
    badge: "Understand the concept",
    title: "How exactly does it work?",
    subtitle:
      "A direct exchange between two people, without intermediaries or complicated point systems",
    etymology: {
      title: "The origin of the word",
      historicalTitle: "An ancient practice",
      text1:
        'The word "Troc" appears in French in the 14th century, derived from the verb "troquer". It has its roots in the Spanish "trucque" and the Walloon "trouk", evoking the idea of direct exchange.',
      text2:
        'Attested as early as 1364 in the form "truke" in Anglo-Norman documents, then officialized in 1464 in the letters patent of Louis XI: "for the sale, barter or exchange of said goods".',
      text3:
        "At DONKEY TRAVEL, we kept this ancestral philosophy: you exchange your home directly with another owner. No virtual currency, no points to accumulate. Just an agreement between two humans.",
      from: "Etymology",
      meaning: "Exchange directly, person to person",
      century14: "14th century",
      firstAttestation: "First attestation in French",
      century15: "15th century",
      officialUse: "Official use by Louis XI",
      today: "Today",
      modernPractice: "Modern and collaborative practice",
    },
    direct: {
      title: "Direct exchange only",
      description:
        "Unlike point or credit systems, DONKEY TRAVEL works on the pure barter principle. You negotiate directly with another owner: your nights for theirs. This is the very essence of barter as it has existed since the 14th century.",
      result: "Direct exchange validated!",
    },
    noTriangulation: {
      title: "No triangulation",
      description:
        "No complex system where A gives to B who gives to C. Here, it's simple: you find someone, you negotiate together (simultaneous or deferred dates), you exchange. Period.",
      noPoints: "No points to count",
    },
    meetHost: {
      title: "Meet another Airbnb host",
      description:
        "DONKEY TRAVEL isn't just about discovering a property or traveling. It's above all about meeting another hospitality enthusiast, someone who shares your values of welcoming guests. Barter has always been a social practice before being an economic one.",
      share: "Share your hosting experiences",
      tips: "Exchange your best tips",
      friendship: "Create lasting friendships",
      badge: "Host community",
      badgeSub: "Authentic encounters",
      step2Title: "2. Friendly agreement on DONKEY TRAVEL",
      step2Desc:
        "They sign the exchange agreement directly on the platform and receive the PDF by email. Everything is secure and official.",
      contractSigned: "Contract signed and secured",
      step3Title: "3. Marie arrives in Paris (2 weeks later)",
      step3Desc:
        "Jean welcomes Marie warmly. He's impressed: the apartment is impeccable, Marie respects everything. What a difference from some Airbnb travelers! They discuss their hosting experiences over coffee.",
      step4Title: "4. Jean discovers Reims (6 months later)",
      step4Desc:
        "Jean arrives at Marie's cottage in Reims. The setting is beautiful! Marie invites him to dinner, they eat together and discuss travel, Airbnb and their best hosting stories.",
      step5Title: "5. A lasting friendship",
      step5Desc:
        "Marie and Jean stay in touch. They decide to regularly exchange their properties. More than just a swap, a real friendship was born thanks to TRAVELTROK.",
      spiritTitle: "That's the DONKEY TRAVEL spirit!",
      spiritDesc:
        "Authentic exchanges between passionate owners, with respect and friendliness. No points, no triangulation, just real old-fashioned bartering.",
    },
    negotiation: {
      badge: "Fun negotiation",
      title: "Negotiate like a game!",
      description:
        "10 nights for 5? Why not! Make an offer, receive a counter-offer, find an agreement. All in a friendly spirit. Like in the early days of exchange, negotiation is part of the fun.",
      marieProperty: "Cottage in Reims",
      jeanProperty: "Apartment in Paris",
      marieLocation: "In her cottage in Reims",
      jeanLocation: "In his apartment in Paris",
      marieAccepts: "Marie accepts the offer",
      offers: "Offers",
      proposes: "Proposes",
      nights: "nights",
      status: {
        initial: "Marie makes an offer...",
        counter: "Jean makes a counter-offer!",
        negotiate: "Marie negotiates...",
        deal: "Deal done! 🎉",
      },
      chat: {
        msg1: "I offer you {{marieNights}} nights in my cottage in Reims for {{jeanNights}} nights in Paris!",
        msg2: "Jean finds Marie's place very nice...",
        msg3: "Your cottage is gorgeous! I'm feeling generous, I'll offer you {{jeanNights}} nights in Paris 😊",
        msg4: "Deal! 🤝",
        msg5: "Marie checks Jean's availability...",
      },
      nextStep: "Next step",
      restart: "Start over",
      points: {
        flexible: "Flexible negotiation",
        friendly: "Friendly atmosphere",
        fair: "Fair agreement",
      },
    },
    flexibility: {
      title: "Total flexibility",
      description:
        "Unlike traditional exchanges, you don't need to find someone who wants your property exactly when you want theirs. Accumulate Nights and use them whenever you like!",
    },
    example: {
      person1: "Marie",
      location1: "Paris, France",
      person2: "Jean",
      location2: "Lyon, France",
      result: "Successful exchange!",
    },
  },
  exchange: {
    title: "How does it work?",
    subtitle:
      "A simple and secure system to exchange your properties with confidence",
    features: {
      secure: {
        title: "Secure exchanges",
        description:
          "All members are verified and reviews guarantee transparency for each exchange.",
      },
      sync: {
        title: "Calendar synchronization",
        description:
          "Automatically sync your availability with your existing Airbnb calendar.",
      },
      global: {
        title: "European network",
        description:
          "Access verified host members in available European countries on TRAVELTROK.",
      },
      chat: {
        title: "Integrated messaging",
        description:
          "Communicate directly with other owners to organize your exchanges.",
      },
      rating: {
        title: "Rating system",
        description:
          "Check reviews and ratings to choose your exchange partners with confidence.",
      },
      savings: {
        title: "Guaranteed savings",
        description:
          "Travel for free using your Nights instead of paying for expensive accommodations.",
      },
    },
    steps: {
      title: "In 3 simple steps",
      step1: {
        title: "Create your profile",
        description:
          "Sign up and add your Airbnb property information in just a few minutes.",
      },
      step2: {
        title: "Find your destination",
        description:
          "Browse available properties and find your dream destination.",
      },
      step3: {
        title: "Exchange and travel",
        description:
          "Propose an exchange, confirm dates and enjoy your stay for free!",
      },
    },
  },
  worldMap: {
    title: "Top 20 most active countries",
    subtitle: "Discover where property exchanges are most popular today",
    description:
      "Our community grows every day with new owners around the world. Discover where you could travel for free.",
    badge: "Real-time ranking",
    properties: "properties",
    cta: "See all destinations",
    exchangesToday: "Exchanges today",
    activeCountries: "Active countries",
    vsYesterday: "vs. yesterday",
    fullRanking: "Full ranking",
    countries: {
      Guadeloupe: "Guadeloupe",
      Martinique: "Martinique",
      Guyane: "French Guiana",
      "La Réunion": "Réunion",
      Mayotte: "Mayotte",
      "Polynésie française": "French Polynesia",
      "Nouvelle-Calédonie": "New Caledonia",
      "Îles Canaries": "Canary Islands",
      "Ceuta & Melilla": "Ceuta & Melilla",
      Madère: "Madeira",
      Açores: "Azores",
      Aruba: "Aruba",
      Curaçao: "Curaçao",
      "Saint-Martin": "Sint Maarten",
      Bermudes: "Bermuda",
      "Îles Caïmans": "Cayman Islands",
      Gibraltar: "Gibraltar",
      france: "France",
      spain: "Spain",
      italy: "Italy",
      usa: "United States",
      uk: "United Kingdom",
      germany: "Germany",
      portugal: "Portugal",
      netherlands: "Netherlands",
      canada: "Canada",
      australia: "Australia",
      belgium: "Belgium",
      switzerland: "Switzerland",
      greece: "Greece",
      mexico: "Mexico",
      brazil: "Brazil",
      austria: "Austria",
      croatia: "Croatia",
      thailand: "Thailand",
      morocco: "Morocco",
    },
  },
  calendar: {
    title: "Automatic synchronization with Airbnb",
    subtitle: "Connect your Airbnb calendar in one click",
    description:
      "Your availability syncs automatically. No need to manage two separate calendars.",
    features: {
      sync: {
        title: "Bidirectional synchronization",
        description:
          "Your Airbnb and DONKEY TRAVEL calendars always stay up to date automatically",
      },
      realtime: {
        title: "Real-time updates",
        description: "Every change is instantly synchronized on both platforms",
      },
      smart: {
        title: "Smart management",
        description:
          "Avoid double bookings with our advanced synchronization system",
      },
    },
    cta: "Connect my calendar",
  },
  airbnb: {
    title: "Already an Airbnb owner?",
    subtitle: "Join DONKEY TRAVEL and start traveling for free",
    description:
      "Automatically import your Airbnb property information and start exchanging today.",
    features: {
      verification: {
        title: "Automatic verification of your profile",
      },
      import: {
        title: "Import your photos and descriptions",
      },
      trust: {
        title: "Join a trusted community",
      },
    },
    cta: "Connect my Airbnb",
  },
  membersMap: {
    title: "Members Map",
    searchPlaceholder: "Search by destination, city...",
    filters: "Filters",
    radius: "Radius",
    radiusAuto: "Auto",
    reset: "Reset",
    filterPets: "Pets allowed",
    filterVerified: "Verified hosts",
    filterRating: "4.8+",
    filterAllTypes: "All types",
    oneTraveler: "1 traveler",
    multipleTravelers: "{{count}} travelers",
    dates: "Dates",
    addDates: "Add dates",
    startDate: "Check-in",
    endDate: "Check-out",
    listingsTitle: "Properties",
    listingsSubtitle: "Select to view on map.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Clear filters",
    guestsShort: "p.",
    bedroomsShort: "br.",
    surfaceAreaUnit: "m²",
    perNight: "/ night",
    online: "Online",
    offline: "Offline",
    verified: "Verified",
    favorite: "Favorite",
    favorites: "Favorites",
    members: "Members",
    exchanges: "exchanges",
    rooms: "rooms",
    mapTitle: "DONKEY TRAVEL interactive members map",
    countries: "Countries",
    results: "results",
    viewProfile: "View profile",
    proposeExchange: "Propose an exchange",
    showFavoritesOnly: "Show favorites only",
    advancedSearch: "Advanced search",
    refineSearch: "Refine your search",
    activeFilter: "active filter",
    activeFilters: "active filters",
    availabilityDates: "Availability dates",
    quickPeriods: "Quick periods",
    thisMonth: "This month",
    nextMonth: "Next month",
    next3Months: "Next 3 months",
    summer: "Summer",
    autumn: "Autumn",
    winter: "Winter",
    arrival: "Arrival",
    departure: "Departure",
    flexibleDates: "Flexible dates",
    clear: "Clear",
    propertyTypeTitle: "Property type",
    apartment: "Apartment",
    house: "House",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capacity & rooms",
    numberOfTravelers: "Number of travelers",
    all: "All",
    numberOfRooms: "Number of rooms",
    minimumSurface: "Minimum surface",
    equipments: "Amenities",
    wifi: "Wi‑Fi",
    pool: "Pool",
    parking: "Parking",
    airConditioning: "Air conditioning",
    garden: "Garden",
    terrace: "Terrace",
    fireplace: "Fireplace",
    barbecue: "Barbecue",
    bike: "Bike",
    sauna: "Sauna",
    gym: "Gym",
    washingMachine: "Washing machine",
    statusAvailability: "Status & availability",
    onlineAvailability: "Online availability",
    onlineOnly: "Online",
    verifiedMembersOnly: "Verified members only",
    ratingExperience: "Rating & experience",
    minimumRating: "Minimum rating",
    minimumExchanges: "Minimum exchanges",
    matchingMembers: "matching members",
    matchingMember: "matching member",
    seeResults: "See",
    result: "result",
    resetAllFilters: "Reset all filters",
    rating: "Rating",
    travelers: "Travelers",
    contact: "Contact",
    searchMemberCity: "Search a member, city, country...",
    noFavorite: "No favorites",
    addFavoritesHint: "Add members to your favorites by clicking on the heart",
    noMemberFound: "No member found",
    tryModifyFilters: "Try modifying your filters",
    viewAllMembers: "View all members",
    modifyFilters: "Modify filters",
    favoritesOnly: "Favorites only",
    addToFavorites: "Add to favorites",
    removeFromFavorites: "Remove from favorites",
    loading: "Loading...",
    sortBy: "Sort by",
    relevance: "Relevance",
    newest: "Newest",
    noResults: "No results found",
    tryDifferentFilters: "Try adjusting your search filters",
    membersList: "Members List",
    membersFound: "members found",
    visibleMembers: "Visible members",
    legend: "Legend",
    availableProperty: "Available property",
    selected: "Selected",
    visibleByAll: "Visible by all",
    allMembersSeeYou: "All members can see you",
    targetedMode: "Targeted mode",
    countriesSelected: "countries selected",
    countrySelected: "country selected",
    myVisibility: "My visibility",
    whoCanSee: "Who can see my property on the map?",
    visibleByAllTitle: "Visible by all",
    visibleByAllDesc:
      "All community members can see your property and propose an exchange.",
    visibleByAllHint: "Maximum visibility and opportunities",
    active: "ACTIVE",
    targetedModeTitle: "Targeted mode",
    targetedModeDesc:
      "Only members from the countries you are looking for can see your property. Maximum discretion.",
    targetedModeHint: "You only see and are seen by your destinations",
    myDesiredDestinations: "My desired destinations",
    clearAll: "Clear all",
    searchCountry: "Search for a country...",
    member: "member",
    membersCount: "members",
    noCountryFound: "No country found",
    targetedInfoTitle: "Your property will only appear for members in",
    targetedInfoDesc: "Others will not see you on the map.",
    targetedExample:
      "Example: if you only want to go to the Netherlands, only Dutch members will see your profile.",
    selectAtLeastOneCountry:
      "Select at least one country to activate targeted mode.",
    propertyTypes: {
      appartement: "Apartment",
      maison: "House",
      villa: "Villa",
      loft: "Loft",
      luxe: "Luxury",
      insolite: "Unusual",
    },
    pricePerNight: "PRICE PER NIGHT (€)",
    min: "Min",
    max: "Max",
    sortResults: "SORT RESULTS",
    sort: {
      recommended: "✨ Recommended",
      priceAsc: "💶 Price ascending",
      priceDesc: "💎 Price descending",
    },
    amenitiesTitle: "AMENITIES",
    amenitiesTabs: {
      all: "ALL",
      essentials: "ESSENTIALS",
      features: "FEATURES",
      location: "LOCATION",
      safety: "SAFETY",
    },
  },
  amenities: {
    wifi: "Wifi",
    tv: "TV",
    kitchen: "Kitchen",
    washing_machine: "Washing machine",
    ac: "Air conditioning",
    heating: "Heating",
    workspace: "Workspace",
    iron: "Iron",
    hair_dryer: "Hair dryer",
    pool: "Pool",
    hottub: "Hot tub",
    patio: "Patio",
    bbq: "BBQ",
    parking: "Free parking",
    gym: "Gym",
    fireplace: "Fireplace",
    breakfast: "Breakfast",
    beachfront: "Beachfront",
    ski_in_out: "Ski-in/Ski-out",
    lake_access: "Lake access",
    smoke_detector: "Smoke detector",
    first_aid: "First aid kit",
    fire_extinguisher: "Fire extinguisher",
  },
  destinations: {
    title: "Destinations",
    searchPlaceholder: "Search for a destination...",
    destinationsFound: "destinations found",
    noResults: "No results",
    tryDifferentSearch: "Try a different search",
    sortMembers: "Most members",
    sortProperties: "Most properties",
    sortName: "Name (A-Z)",
    all: "All",
    members: "members",
    properties: "properties",
    explore: "Explore this destination",
    stats: {
      destinations: "Destinations",
      members: "Members",
      properties: "Properties",
      countries: "Countries",
    },
    countriesIn: "Countries in",
    selectCountry: "— select a country to filter",
    continents: {
      Europe: "Europe",
      "Amérique du Nord": "North America",
      "Amérique du Sud": "South America",
      Asie: "Asia",
      Afrique: "Africa",
      Océanie: "Oceania",
    },
    countries: {
      Turquie: "Turkey",
      France: "France",
      "Pays-Bas": "Netherlands",
      "Royaume-Uni": "United Kingdom",
      Espagne: "Spain",
      Italie: "Italy",
      Tchéquie: "Czech Republic",
      Grèce: "Greece",
      Portugal: "Portugal",
      Autriche: "Austria",
      Écosse: "Scotland",
      Hongrie: "Hungary",
      Croatie: "Croatia",
      Danemark: "Denmark",
      Suède: "Sweden",
      Suisse: "Switzerland",
      Belgique: "Belgium",
      Norvège: "Norway",
      Irlande: "Ireland",
      Pologne: "Poland",
      Finlande: "Finland",
      Islande: "Iceland",
      Roumanie: "Romania",
      Monténégro: "Montenegro",
      "États-Unis": "United States",
      Canada: "Canada",
      Mexique: "Mexico",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "Dominican Rep.",
      Guatemala: "Guatemala",
      Brésil: "Brazil",
      Argentine: "Argentina",
      Pérou: "Peru",
      Colombie: "Colombia",
      Chili: "Chile",
      Équateur: "Ecuador",
      Uruguay: "Uruguay",
      Bolivie: "Bolivia",
      Chine: "China",
      Thaïlande: "Thailand",
      Indonésie: "Indonesia",
      Vietnam: "Vietnam",
      "Corée du Sud": "South Korea",
      Inde: "India",
      Cambodge: "Cambodia",
      Jordanie: "Jordan",
      Maldives: "Maldives",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Philippines",
      Ouzbékistan: "Uzbekistan",
      Égypte: "Egypt",
      Maroc: "Morocco",
      "Afrique du Sud": "South Africa",
      Tanzanie: "Tanzania",
      Kenya: "Kenya",
      Sénégal: "Senegal",
      Madagascar: "Madagascar",
      Tunisie: "Tunisia",
      Zimbabwe: "Zimbabwe",
      Namibie: "Namibia",
      "Île Maurice": "Mauritius",
      Rwanda: "Rwanda",
      Australie: "Australia",
      "Nouvelle-Zélande": "New Zealand",
      "Polynésie française": "French Polynesia",
      Fidji: "Fiji",
      "Nouvelle-Calédonie": "New Caledonia",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "Paris",
      "Mont Saint-Michel": "Mont Saint-Michel",
      Marseille: "Marseille",
      Amsterdam: "Amsterdam",
      Londres: "London",
      Barcelone: "Barcelona",
      Madrid: "Madrid",
      Venise: "Venice",
      Rome: "Rome",
      "Côte Amalfitaine": "Amalfi Coast",
      Prague: "Prague",
      Santorin: "Santorini",
      Athènes: "Athens",
      Lisbonne: "Lisbon",
      Porto: "Porto",
      Vienne: "Vienna",
      Édimbourg: "Edinburgh",
      Budapest: "Budapest",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Copenhagen",
      Stockholm: "Stockholm",
      Zermatt: "Zermatt",
      Bruges: "Bruges",
      Bergen: "Bergen",
      Dublin: "Dublin",
      Cracovie: "Krakow",
      Helsinki: "Helsinki",
      Reykjavik: "Reykjavik",
      Bucarest: "Bucharest",
      Kotor: "Kotor",
      "New York": "New York",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Angeles",
      Miami: "Miami",
      Hawaï: "Hawaii",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Quebec City",
      Cancún: "Cancún",
      "Mexico City": "Mexico City",
      "San José": "San José",
      "La Havane": "Havana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Rio de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogotá",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokyo",
      Kyoto: "Kyoto",
      Pékin: "Beijing",
      Shanghai: "Shanghai",
      "Hong Kong": "Hong Kong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Ho Chi Minh City",
      Séoul: "Seoul",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Kathmandu",
      Manille: "Manila",
      Samarcande: "Samarkand",
      Petra: "Petra",
      "Le Caire": "Cairo",
      Marrakech: "Marrakech",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Cape Town",
      Johannesburg: "Johannesburg",
      Zanzibar: "Zanzibar",
      "Safari Masai Mara": "Masai Mara Safari",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarivo",
      Tunis: "Tunis",
      "Chutes Victoria": "Victoria Falls",
      Windhoek: "Windhoek",
      "Île Maurice": "Mauritius",
      Kigali: "Kigali",
      Sydney: "Sydney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Great Barrier Reef",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fiji",
      Nouméa: "Nouméa",
      Apia: "Apia",
      "Baie d'Halong": "Ha Long Bay",
      Maldives: "Maldives",
    },
  },
  story: {
    badge: "A true story",
    title: "Chloé & Hugo: the perfect swap",
    subtitle:
      "When a Parisian tired of city life meets a countryside dweller dreaming of Paris...",
    chloé: {
      aptAlt: "Chloé's apartment in Paris",
      quotaExceeded: "Airbnb quota exceeded!",
      role: "Airbnb host in Paris",
      speech1:
        "I've <strong class=\"text-red-600\">exceeded my 120-night quota</strong>... Can't rent anymore. And honestly, I'm tired of the Parisian noise. 😩",
      nightsTag: "120/120 nights",
      tiredTag: "Tired of Paris",
      dreamsOf: "Chloé dreams of...",
      dreamTitle: "The calm of the countryside",
      dreamDesc: "Greenery, silence, a sauna... paradise!",
      searching: "Looking for a countryside cottage",
      findsLuc: "Finds Hugo!",
      speech2:
        "Finally some peace! The sauna after a forest walk is <strong>pure bliss</strong>. 🌿✨",
      review:
        "Hugo's cottage is a little paradise! The sauna after a forest walk is pure happiness. We became friends! I recommend 200%.",
    },
    hugo: {
      giteAlt: "Hugo's cottage in the countryside",
      available: "Available year-round",
      location: "Countryside, France",
      role: "Airbnb host in the countryside",
      speech1:
        'My cottage has a <strong class="text-sage-600">garden, sauna and massage chair</strong>... but I can\'t stand the countryside anymore. I dream of Paris! 🗼',
      dreamsOf: "Hugo dreams of...",
      dreamTitle: "The lights of Paris",
      dreamDesc: "Museums, cafés, the Eiffel Tower... finally!",
      searching: "Looking for an apartment in Paris",
      findsMaya: "Finds Chloé!",
      speech2:
        "Paris, at last! The Louvre, the bistros, the rooftops... it's <strong>magical</strong>! 🗼🥐",
      review:
        "Chloé's apartment is incredible, with views over the Paris rooftops! And all without touching her quota. Swapping is amazing!",
    },
    tags: {
      garden: "Garden",
      sauna: "Sauna",
      massage: "Massage",
      countryside: "Countryside",
      bigGarden: "Large garden",
      restaurants: "Restaurants",
      museums: "Museums",
    },
    match: {
      spark: "The spark!",
      title: "They discover DONKEY TRAVEL",
      perfect: "Perfect match!",
    },
    quota: {
      title: "Outside Airbnb quota = 100% free!",
      description:
        "Hugo's stay doesn't count towards Chloé's quota. It's a swap, not a rental. Everyone wins!",
      totalCost: "Total cost",
      quotaNight: "Quota night",
    },
    happyEnd: {
      title: "Everyone is happy! 🎊",
      subtitle:
        "Chloé and Hugo became friends. They share hosting tips and are already planning their next exchange!",
      exchangeSuccess: "Successful exchange",
      newFriendship: "New friendship",
      outsideQuota: "Outside quota",
      free: "100% free",
    },
  },
  messaging: {
    messages: "Messages",
    searchPlaceholder: "Search a conversation...",
    all: "All",
    unread: "Unread",
    archived: "Archived",
    online: "Online",
    offline: "Offline",
    messagePlaceholder: "Write a message...",
    writeMessage: "Write a message",
    sending: "Sending...",
    characters: "characters",
    noConversation: "No conversation",
    notificationMessage: "New message",
    quickActions: "Quick actions",
    proposeExchange: "Propose an exchange",
    proposeExchangeTitle: "Exchange proposal",
    checkAvailability: "Check availability",
    report: "Report",
    hisProperty: "Their property",
    rooms: "rooms",
    guests: "guests",
    verifiedOwner: "Verified owner",
    viewAirbnbListing: "View Airbnb listing",
    details: "Details",
    desiredDates: "Desired dates",
    arrival: "Arrival",
    departure: "Departure",
    period: "Period",
    duration: "Duration",
    nights: "nights",
    numberOfTravelers: "Number of travelers",
    traveler: "traveler",
    travelers: "travelers",
    person: "person",
    persons: "persons",
    dateFlexibility: "Date flexibility",
    exactDates: "Exact dates",
    flex1to2: "± 1-2 days",
    flex3to5: "± 3-5 days",
    flexWeek: "± 1 week",
    personalMessage: "Personal message",
    summary: "Summary",
    termsAccept: "I accept DONKEY TRAVEL exchange terms",
    sendProposal: "Send proposal",
    proposalSent: "Proposal sent!",
    proposalSentMessage: "Your proposal has been sent successfully",
    close: "Close",
    today: "Today",
    selectConversation: "Select a conversation",
    selectConversationHint: "Choose an owner to start chatting",
  },
  destination_introuvable: `Destination not found`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `This destination does not exist or has been moved.`,
  retour_aux_destinations: `Back to destinations`,
  pr_t___d_couvrir_: `Ready to discover `,
  r_server_ce_s_jour: `Book this stay`,
  explorer_d_apos_autres_destinations: `Explore other destinations`,
  acc_s_r_serv_: `Restricted access`,
  europe_unique: `Single Europe`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `EUR50/year for exchanges across Europe.`,
  lancement_2026: `2026 launch`,
  club_d__change_h_tes_airbnb: `Airbnb hosts exchange club`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Use exchanges to optimize low season`,
  rejoindre_le_club: `Join the club`,
  trouver_un_h_te: `Find a host`,
  r_serv__aux_h_tes_traveltrok: `Reserved for DONKEY TRAVEL hosts`,
  voyagez_gratuitement_gr_ce___votre_logement: `Travel for free thanks to your home`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Host members and get hosted in return. A simple, direct, and money-free exchange between owners.`,
  devenir_h_te: `Become a host`,
  comment__a_marche__: `How it works?`,
  amis_partageant_un_repas_en_corse: `Friends sharing a meal in Corsica`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"We exchanged our house in Lyon for a villa in Corsica. Cost: €0."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, members since 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `No currency, no points. Just an agreement between two owners. I come to your place, you come to mine.`,
  "1__accord_mutuel": `1. Mutual agreement`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `You find a member you like and agree to exchange your homes.`,
  "2__flexibilit__totale": `2. Total flexibility`,
  "3__z_ro_comptabilit_": `3. Zero accounting`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `No points to count. Just the pleasure of sharing and meeting.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `Why hosts love this system?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `More than savings, it's a new way to travel.`,
  "0__de_frais": `€0 fees`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Exchanges are totally free. No service fees, no cleaning fees (unless agreed otherwise).`,
  confiance_totale: `Total trust`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Only verified hosts can exchange. You host someone who knows the value of a home.`,
  simplicit_: `Simplicity`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Forget point values. A night is a night. The exchange is based on trust between hosts.`,
  rejoignez_la_communaut__des_h_tes: `Join the host community`,
  rejoignez_la_communaut__et_commencez____changer_: `Join the community and start exchanging.`,
  commencer_maintenant: `Start now`,
  pr_nom_invalide: `Invalid first name`,
  nom_invalide: `Invalid last name`,
  email_invalide: `Invalid email`,
  s_lectionne_un_pays: `Select a country`,
  s_lectionne_un_mode_tarifaire: `Select a pricing mode`,
  s_lectionne_ton_usage: `Select your usage`,
  tu_dois_accepter_les_conditions: `You must accept the terms`,
  france: `France`,
  belgique: `Belgium`,
  suisse: `Switzerland`,
  canada: `Canada`,
  allemagne: `Germany`,
  espagne: `Spain`,
  italie: `Italy`,
  portugal: `Portugal`,
  royaume_uni: `United Kingdom`,
  _tats_unis: `United States`,
  autre: `Other`,
  merci_de_corriger_les_champs_en_erreur_: `Please fix the fields with errors.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `An error occurred. Try again in a moment.`,
  compte_cr___avec_succ_s: `Account created successfully`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `You will receive an email to finish setting up your traveler/host profile.`,
  cr_er_un_autre_compte: `Create another account`,
  activation_traveltrok: `DONKEY TRAVEL activation`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Choose your mode: traveler, host, or mixed usage.`,
  pr_nom: `First name`,
  jeanne: `Jane`,
  nom: `Last name`,
  durand: `Doe`,
  email: `Email`,
  jeanne_email_com: `jane@email.com`,
  t_l_phone__optionnel_: `Phone (optional)`,
  pays: `Country`,
  choisir_un_pays: `Choose a country`,
  mode_tarifaire: `Pricing mode`,
  voyageur: `Traveler`,
  nuit: `night`,
  h_te: `Host`,
  pro_multi_logements: `Pro multi-property`,
  mois: `month`,
  usage_principal: `Main usage`,
  je_voyage_principalement: `I mostly travel`,
  je_loue_principalement: `I mostly host`,
  je_fais_les_deux: `I do both`,
  nombre_de_logements: `Number of properties`,
  logement: `property`,
  logements: `properties`,
  a: `to`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `I accept the terms of use and the privacy policy.`,
  cr_ation_en_cours___: `Creating account...`,
  cr_er_mon_compte_traveltrok: `Create my DONKEY TRAVEL account`,
  r_servation_de_logements: `Property booking`,
  support_h_te_prioritaire: `Priority host support`,
  carte___filtres_avanc_s: `Map + advanced filters`,
  flux_de_r_servation__tape_par__tape: `Step-by-step booking flow`,
  couverture_dommages_assistance: `Damage/assistance coverage`,
  multi_logements___reporting: `Multi-property + reporting`,
  accueil: `Home`,
  tarifs: `Pricing`,
  "0__commission_pour_les_h_tes": `0% Commission for hosts`,
  r_volution_traveltrok: `DONKEY TRAVEL revolution`,
  gardez_100__de_ce_que_vous_gagnez: `Keep 100% of what you earn`,
  simple: `Simple`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `You know your cost before booking. No surprises at checkout.`,
  honn_te: `Fair`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `Same rule for everyone: travelers and hosts are treated equally.`,
  utile: `Useful`,
  je_suis_voyageur: `I'm a traveler`,
  je_suis_h_te: `I'm a host`,
  j_ai_plusieurs_logements: `I have multiple properties`,
  simulateur_comparatif_host: `Host comparison simulator`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Compare Booking, Airbnb, and DONKEY TRAVEL with your own numbers.`,
  nombre_de_nuits: `Number of nights`,
  property_price___night__eur_: `Property price / night (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Other fees (cleaning, check-in, linen...) EUR`,
  option___qui_paie_les_frais__5____: `Option: Who pays the fees (5%)?`,
  standard__recommand__: `Standard (Recommended)`,
  pro___attractivit_: `Pro / Attractiveness`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `Traveler pays 5% extra. You get 100% of the price.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `You pay the 5%. Price shown to traveler is net.`,
  base_de_calcul: `Calculation base`,
  nuit_s_: `night(s)`,
  autres_frais: `Other fees`,
  montant_total_avant_commissions: `Total amount before commissions`,
  plateforme: `Platform`,
  frais_h_te: `Host fee`,
  frais_voyageur: `Traveler fee`,
  total_voyageur: `Traveler total`,
  net_h_te: `Host net`,
  avantage_fiscal___pro: `Tax & Pro Advantage`,
  consultez_votre_expert_comptable_: `Consult your tax expert.`,
  diff_rence_h_te__claire_et_vendeuse: `Host difference: clear and compelling`,
  frais_h_te___an: `Host fees / year`,
  _conomie_compar_e___booking: `Savings vs Booking`,
  _conomie_vs_airbnb: `Savings vs Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Typical 1-year host example`,
  nuits_r_serv_es: `Booked nights`,
  s_jours___an: `Stays / year`,
  chiffre_d_affaires_annuel: `Annual gross revenue`,
  frais_traveltrok: `DONKEY TRAVEL fees`,
  frais_booking__15__: `Booking fees (15%)`,
  frais_airbnb__15_5__: `Airbnb fees (15.5%)`,
  net_h_te_traveltrok: `DONKEY TRAVEL host net`,
  comparatif_des_modes: `Mode comparison`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `What you enable based on your DONKEY TRAVEL usage.`,
  fonction: `Feature`,
  pro: `Pro`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Create your account and usage mode`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Choose whether you start as traveler, host, or both. You can change at any time.`,
  location_simple_c_t__voyageur: `Simple traveler-side rental`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Search, filters, quick booking, and transparent cost.`,
  gestion_h_te_simplifi_e: `Simplified host management`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Publish your property, manage your calendar, and respond quickly to requests.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Coverage included for both traveler and host.`,
  support_op_rationnel: `Operational support`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Assistance in case of dispute, cancellation, or mediation needs.`,
  faq_tarifs: `Pricing FAQ`,
  vraiment_0__de_commission_pour_l_h_te__: `Really 0% commission for the host?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Yes. The host receives 100% of the price they set. No service fees, no processing fees.`,
  combien_paie_le_voyageur__: `How much does the traveler pay?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `The traveler pays a 5% commission on the rental amount. This covers operating costs, insurance, and support.`,
  puis_je__changer_mon_logement_gratuitement__: `Can I exchange my home for free?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Yes! If you are a host, you can exchange your home with other members for free (€0).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `Why is this model cheaper?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `By taking only 5% total (vs 15-20% elsewhere), we make travel more accessible while rewarding hosts better.`,
  pr_t___activer_ton_mode_traveltrok__: `Ready to activate your DONKEY TRAVEL mode?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Traveler, host, or hybrid: start with a clear model and controlled costs.`,
  cr_er_mon_compte: `Create my account`,
  explorer_les_logements: `Explore homes`,
  donn_es_personnelles: `Personal data`,
  politique_de_confidentialit_: `Privacy Policy`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Join our community and book a stay in {{city}} with clear fixed fees and included insurance.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `A European exchange platform reserved for Airbnb hosts`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Private club for hosts rated 4.5+: one single subscription to exchange across Europe.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Reserved for Airbnb hosts with a rating of 4.5 or higher.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `50% discount in 2026: EUR25/year instead of EUR50/year. Lifetime price guaranteed for the first 1,000 members.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Low season, rest periods, host networking, vacation savings: everything is built for active hosts in Europe.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Travel for less (5% fee), host for free (0%). The fairest model on the market.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `No more 15% commissions. With DONKEY TRAVEL, hosts pay zero fees. Travelers pay only 5% service fees. That is fairness.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Comparison assumption: Booking host commission 15% (depending on country and program), Airbnb host-only mode at 15.5% host side and 0 traveler side.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `The 5% fee may be deductible from your expenses if you are a company. The 0% model simplifies accounting for individuals.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `With DONKEY TRAVEL, you can lower your nightly price to book more often. Host fees stay fixed, so your net stays strong.`,
  en_moyenne__c_est_environ___annualhostcase_average: `On average, that is about €{{savings}} in yearly savings versus commission-based platforms.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Assumptions: €100 per night, €30 cleaning fee, 3-night average stay, 50% yearly occupancy rate.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL only collects data required to operate the service: account, profile, exchanges, and support.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Your data is only shared with essential technical services (authentication, hosting, security) and is never sold.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `You can request updates or deletion of your personal data from your account or by contacting support.`,
  "help.faq.q1.question": "How much does the subscription cost?",
  "help.faq.q1.answer":
    "€50/year for the classic plan. There is a launch discount at €25/year for 2026.",
  "help.faq.q2.question": "Can I exchange without having the same dates?",
  "help.faq.q2.answer":
    "Absolutely. Our flexible exchange system allows host 1 to come to host 2's place in July, and host 2 to come to host 1's place in September, asynchronously.",
  "help.faq.q3.question":
    "Is the site really reserved for hosts rated 4.5 and above?",
  "help.faq.q3.answer":
    "Yes. Donkey Travel is a closed club. Upon registration, we verify the link to your Airbnb listing to ensure your average rating is at least 4.5/5 and that you have reviews.",
  "help.faq.q4.question": "How are the exchanges organized?",
  "help.faq.q4.answer":
    "There is no points system. Members decide for themselves how many nights they want to exchange based on the price they indicate. The Airbnb listing serves as a reference to verify if the proposal is fair and credible.",
  "help.faq.q5.question": "Are there additional fees (cleaning, service)?",
  "help.faq.q5.answer":
    "No! The principle of Donkey Travel is 100% free exchange between hosts. The hosting host prepares the accommodation, and the guest returns it in an impeccably clean state (or manages the cleaning with the host according to their agreements).",
  "help.faq.q6.question": "Can I link multiple Airbnb listings?",
  "help.faq.q6.answer":
    "Yes, this is planned in our upcoming updates to allow you to synchronize multiple accommodations and gain even more exchange opportunities.",
  "help.faq.q7.question": "What happens if an exchange is canceled?",
  "help.faq.q7.answer":
    "In case of cancellation, we invite you to communicate with your host via our internal messaging to find a new agreement or new dates.",
  "help.faq.q8.question": "How are trust and security guaranteed?",
  "help.faq.q8.answer":
    "By only accepting confirmed hosts (rating > 4.5), we ensure that all members know what it means to 'host'. Furthermore, identity and listings are verified by our team.",
};
